import { useTranslation } from 'react-i18next';
import { Badge, BadgeVariant } from '../Badge';
import { I18nNamespace } from '@/lib/i18n-namespaces';

interface ConfidenceBadgeProps {
    value: number;
    glass?: boolean;
    compact?: boolean;
    className?: string;
}

function getConfidenceVariant(value: number, glass: boolean): BadgeVariant {
    if (value >= 75) return glass ? 'positive-glass' : 'positive';
    if (value >= 55) return glass ? 'warning-glass' : 'warning';
    return glass ? 'negative-glass' : 'negative';
}

export function ConfidenceBadge({
    value,
    glass = false,
    compact = false,
    className,
}: ConfidenceBadgeProps) {
    const { t } = useTranslation(I18nNamespace.COMMON);
    const label = compact
        ? `${Math.round(value)}%`
        : `${Math.round(value)}% ${t('confidence.match')}`;
    return (
        <Badge
            value={label}
            variant={getConfidenceVariant(value, glass) || 'neutral'}
            className={className}
        />
    );
}
